import BaseAssetClasses from './BaseAssetClasses';
import AssetClassesContainer from './AssetClassesContainer';

export default AssetClassesContainer;
export { BaseAssetClasses };
